import React from "react";

const ArrowIcon = ({svgClass, thick=true}) => {
    return (
        <>
            { !thick && <svg id="Layer_1" className={svgClass} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 156 383"><path style={{fill: "currentcolor"}} d="M149.95,2.56h0c-6.42-4.48-15.26-2.93-19.75,3.47L0,191.49h0s0,.01,0,.01l130.2,185.46c4.49,6.4,13.34,7.96,19.75,3.47h0c6.42-4.48,7.98-13.3,3.48-19.7L34.63,191.5,153.43,22.26c4.49-6.4,2.93-15.22-3.48-19.7Z" fill="#231f20"/></svg>}
            { thick && <svg id="Layer_1" className={svgClass} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 156 254"><path style={{fill: "currentcolor"}} d="M57.98,127.16l93.11-93.17c6.55-6.55,6.55-17.17,0-23.73l-5.34-5.35c-6.55-6.55-17.16-6.55-23.71,0L.32,126.71l.13.13-.44.44,121.72,121.8c6.55,6.55,17.16,6.55,23.71,0l5.34-5.35c6.55-6.55,6.55-17.17,0-23.73L57.98,127.16Z" fill="#231f20"/></svg>}
        </>
    );
};

export default ArrowIcon;